export default __webpack_public_path__ + "static/media/mainpic4.fbe8191c.png";